import { Mic20Regular, Send20Regular, Pause20Regular } from "@/components/Icon";
import { IconButton } from "@mui/material";
import Tooltip from "@/components/Tooltip";
import styles from "./index.module.scss";

export default function AiAskBarRightActionsDefault({
  handleSend,
  sendDisabled,
  sendIsActive,
  isSendPulsing,
  onVoiceToggle,
  voiceActive = false,
  isGenerating = false,
  onStopGenerating,
}) {
  return (
    <>
      <Tooltip
        text={voiceActive ? "stop voice mode" : "start voice mode"}
        placement="bottom"
      >
        <IconButton
          type="button"
          className={styles.circleAction}
          aria-label={voiceActive ? "Stop voice mode" : "Start voice mode"}
          onClick={onVoiceToggle}
          disabled={isGenerating}
        >
          <Mic20Regular className={styles.circleIcon} aria-hidden />
        </IconButton>
      </Tooltip>
      {isGenerating ? (
        <Tooltip text="stop generating" placement="bottom">
          <IconButton
            type="button"
            className={`${styles.circleAction} ${styles.circleActionStop}`}
            onClick={onStopGenerating}
            aria-label="Stop generating"
          >
            <Pause20Regular className={styles.circleIcon} aria-hidden />
          </IconButton>
        </Tooltip>
      ) : (
        <Tooltip text="send prompt" placement="bottom">
          <IconButton
            type="button"
            className={`${styles.circleAction}${sendIsActive ? ` ${styles.circleActionSendActive}` : ""}${isSendPulsing ? ` ${styles.circleActionSendPulse}` : ""}`}
            onClick={handleSend}
            aria-label="Send"
            disabled={sendDisabled}
          >
            <Send20Regular className={styles.circleIcon} aria-hidden />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}
